<template>
    <section class="bg-[#f9f9f9] py-20 px-4 relative">
      <div class="max-w-[1140px] mx-auto text-center mb-12">
        <h2 class="text-2xl md:text-4xl font-bold mb-2">
          Veja todos os detalhes de cada plano.
        </h2>
        <p class="text-sm text-gray-500">
          Painel cPanel + Painéis Exclusivos da Integrator
        </p>
      </div>
  
      <div class="overflow-x-auto">
        <div class="w-full max-w-[1140px] mx-auto">
          <table class="w-full text-sm bg-transparent shadow-none rounded-none border-collapse">
            <thead>
              <tr>
                <th class="w-1/4 text-left p-4"></th>
                <th
                  v-for="(plano, index) in planos"
                  :key="plano.id"
                  class="relative text-center pt-10 p-6 border-l border-gray-200 bg-white align-top py-16"
                >
                  <!-- Badge MAIS POPULAR -->
                  <div
                    v-if="index === 1"
                    class="absolute top-2 left-1/2 -translate-x-1/2 bg-yellow-400 text-xs font-bold text-black px-2 py-0.5 rounded shadow"
                  >
                    MAIS POPULAR
                  </div>
  
                  <!-- Conteúdo do card -->
                  <div class="text-[22px] font-bold text-gray-900 mt-6 mb-6">{{ plano.nome }}</div>
                  <div class="text-gray-900 text-xs mb-2 font-light">{{ getDescontoTexto(plano) }}</div>
                  <div class="text-3xl font-extrabold text-cormenubotaoplanos mb-6">
                    R$ {{ calcularDesconto(plano) }}<span class="text-base font-medium">/mês</span>
                  </div>
  
                  <router-link
                    :to="`/assineja-hospedagem-java?planoId=${plano.id}`"
                    class="bg-cormenubotaoplanos text-white px-6 py-2 rounded-full font-semibold hover:brightness-110 transition mb-2 inline-block"
                  >
                    ASSINE JÁ
                  </router-link>
                  <div class="text-xs text-gray-500 mt-8 font-light">
                    Preço na contratação de {{ periodoSelecionadoJava }} meses
                  </div>
                </th>
              </tr>
            </thead>
  
            <tbody>
              <tr
                v-for="(feature, index) in caracteristicas"
                :key="index"
                class="border-t border-gray-200 bg-white"
              >
                <td class="text-left font-semibold text-gray-700 p-4 bg-white">
                  {{ feature.label }}
                </td>
                <td
                  v-for="(plano, i) in planos"
                  :key="plano.id + '-' + i"
                  class="text-center p-4"
                >
                  <!-- Para checkboxes -->
                  <span v-if="feature.key === 'check'">
                    <span
                      v-if="feature.checks === 'todos' || feature.checks[i]"
                      class="text-green-500 font-bold text-xl"
                    >✓</span>
                    <span v-else class="text-gray-400 font-bold text-xl">✗</span>
                  </span>
  
                  <!-- Para valores personalizados -->
                  <span v-else-if="feature.key === 'custom'">
                    {{ feature.checks[i] }}
                  </span>
  
                  <!-- Padrão -->
                  <span v-else>
                    {{ plano[feature.key] }}{{ feature.suffix ? ' ' + feature.suffix : '' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import axios from '@/services/api'
  import { periodoSelecionadoJava } from '@/store/periodoStore'
  
  const planos = ref([])
  
  onMounted(async () => {
    try {
      const response = await axios.get('/api/planos/listarativos')
      planos.value = response.data
        .filter(p => p.ativo)
        .filter(p => p.planoTipo === 'JAVA')
        .sort((a, b) => a.ordem - b.ordem)
    } catch (error) {
      console.error('Erro ao buscar planos:', error)
    }
  })
  
  const formatPreco = valor => Number(valor).toFixed(2).replace('.', ',')
  
  const getDescontoPercentual = plano => {
    if (periodoSelecionadoJava.value === '6') return plano.desconto2 || 0
    if (periodoSelecionadoJava.value === '12') return plano.desconto3 || 0
    return plano.desconto1 || 0
  }
  
  const calcularDesconto = plano => {
    const desconto = getDescontoPercentual(plano)
    const valorFinal = plano.valor * (1 - desconto / 100)
    return formatPreco(valorFinal)
  }
  
  const getDescontoTexto = plano => {
    const d = getDescontoPercentual(plano)
    return d > 0 ? `${d}% de desconto` : ''
  }
  
  const caracteristicas = [
    { label: 'Processador', key: 'processamento', suffix: 'vCORE @ 3.5 GHz' },
    { label: 'Memória Ram JVM', key: 'ram1' , suffix: ' MB' },
    { label: 'Memória Ram VM', key: 'ram2' , suffix: ' MB' },
    { label: 'Java App(s)', key: 'app' },
    { label: 'Disco SSD NVMe (Raid 10)', key: 'disco' , suffix: ' GB' },
    { label: 'Domínios', key: 'dominios' },
    { label: 'Subdomínios', key: 'subdominios' },
    { label: 'SSL Grátis', key: 'check', checks: 'todos' },
    { label: 'FTP Multiusuário', key: 'check', checks: 'todos' },
    { label: 'Caixas de E-mail', key: 'emails' },
    { label: 'Tamanho caixa E-mail', key: 'custom', checks: ['1 GB', '1 GB', '1 GB'] },
    { label: 'POP3 / SMTP próprios', key: 'check', checks: 'todos' },
    { label: 'Webmail', key: 'check', checks: 'todos' },
    { label: 'Sistema Anti-spam', key: 'check', checks: 'todos' },
    { label: 'Envios por horas', key: 'custom', checks: ['250', '250', '250'] },
    { label: 'MySQL	', key: 'check', checks: 'todos' },
    { label: 'Acesso remoto MySQL', key: 'check', checks: 'todos' },
    { label: 'PostgreSQL', key: 'check', checks: [false, true, true]},
    { label: 'Acesso remoto PostgreSQL', key: 'check', checks: [false, false, false]},
    { label: 'Limite conexões persistentes', key: 'custom', checks: ['40', '40', '40'] },
    { label: 'Inodes', key: 'custom', checks: ['250 mil', '250 mil', '250 mil'] },
    { label: 'Processo Simultâneos', key: 'custom', checks: ['30', '30', '30'] },
    { label: 'JDK 6 até 24', key: 'check', checks: 'todos' },
    { label: 'Deploy .war', key: 'check', checks: 'todos' },
    { label: 'Deploy .jar', key: 'check', checks: 'todos' },
    { label: 'STRUTS', key: 'check', checks: 'todos' },
    { label: 'VRAPTOR', key: 'check', checks: 'todos' },
    { label: 'JASPERREPORTS', key: 'check', checks: 'todos' },
    { label: 'JAVASERVER FACES', key: 'check', checks: 'todos' },
    { label: 'HIBERNATE', key: 'check', checks: 'todos' },
    { label: 'SPRING BOOT', key: 'check', checks: 'todos' },
    { label: 'JPA', key: 'check', checks: 'todos' },
    { label: 'SPRING', key: 'check', checks: 'todos' },
    { label: 'SERVLET', key: 'check', checks: 'todos' },
    { label: 'JAVA EE', key: 'check', checks: 'todos' },
    { label: 'TOMCAT 6 até 10', key: 'check', checks: 'todos' },
    { label: 'JBOSS 7.1', key: 'check', checks: [false, true, true]},
    { label: 'WILDFLY 8 ao 32', key: 'check', checks: [false, true, true]},
    { label: 'GLASFISH 3 ao 7', key: 'check', checks: [false, true, true]},
    { label: 'PAYARA 5', key: 'check', checks: [false, true, true]},
    { label: 'JETTY 8 ao 12', key: 'check', checks: [false, true, true]},
    { label: 'PHP 8.x, 7.x e 5.x', key: 'check', checks: 'todos' },
    { label: 'HTML, JS, Vue, Angular, React', key: 'check', checks: 'todos' },
    { label: 'Perl / CGI', key: 'check', checks: 'todos' },
    { label: 'Wordpress Toolkit', key: 'check', checks: 'todos' },
    { label: 'Instalador de WordPress', key: 'check', checks: 'todos' },
    { label: 'Instalador de Magento', key: 'check', checks: 'todos' },
    { label: 'Instalador de PrestaShop', key: 'check', checks: 'todos' },
    { label: 'Instalador de Joomla', key: 'check', checks: 'todos' },
    { label: 'ImunifyAV', key: 'check', checks: 'todos' },
    { label: 'GIT', key: 'check', checks: 'todos' },
    { label: 'DNS Próprios', key: 'check', checks: 'todos' },
    { label: 'Backup Mensal Arquivos', key: 'check', checks: 'todos' },
    { label: 'Backup Diário MySQL', key: 'check', checks: 'todos' },
    { label: 'Backup Diário PostgreSQL', key: 'check', checks: [false, false, false] },
    { label: 'Antivírus', key: 'check', checks: 'todos' },
    { label: 'Firewall', key: 'check', checks: 'todos' },
    { label: 'Suporte 24h Ticket', key: 'check', checks: 'todos' },
    { label: 'Ajuda via Wiki	', key: 'check', checks: 'todos' },
    { label: 'Link', key: 'custom', checks: ['10 GBits', '10 GBits', '10 GBits'] },
    { label: 'Garantia Uptime', key: 'custom', checks: ['99,99%', '99,99%', '99,99%'] }


  ]
  

  </script>
  
  <style scoped>
  th,
  td {
    min-width: 160px;
  }
  </style>
  